import { formatQty } from "../lib/format.js";
import { isQtyWellFormed, stepQty } from "../lib/quantity.js";

type Sku = { unit: string; isDivisible: boolean; qtyStep: string };

/**
 * Box/piece use a ± stepper; lb/kg use numeric input.
 * An owner typing 100.5 lb on their phone and picking 3 boxes are completely different interactions.
 */
export function QtyInput({
  value,
  sku,
  onChange,
  disabled,
}: {
  value: string;
  sku: Sku;
  onChange: (next: string) => void;
  disabled?: boolean;
}) {
  if (sku.isDivisible) {
    const invalid = value.length > 0 && !isQtyWellFormed(value, sku);
    return (
      <div>
        <div className="flex items-center gap-2">
          <input
            aria-label="수량"
            inputMode="decimal"
            className="w-40 rounded-lg border border-stone-300 px-3 py-3 text-lg"
            value={value}
            disabled={disabled}
            onChange={(e) => onChange(e.target.value)}
          />
          <span className="text-lg">{sku.unit}</span>
        </div>
        {invalid ? (
          <p role="alert" className="mt-1 text-sm text-red-600">
            {sku.qtyStep} {sku.unit} 단위로 입력해 주세요.
          </p>
        ) : null}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        aria-label="수량 줄이기"
        className="h-12 w-12 rounded-lg border border-stone-300 text-xl disabled:opacity-40"
        disabled={disabled || Number(value) <= Number(sku.qtyStep)}
        onClick={() => onChange(stepQty(value, sku.qtyStep, -1))}
      >
        −
      </button>
      <span className="min-w-24 text-center text-lg font-semibold">{formatQty(value, sku)}</span>
      <button
        type="button"
        aria-label="수량 늘리기"
        className="h-12 w-12 rounded-lg border border-stone-300 text-xl disabled:opacity-40"
        disabled={disabled}
        onClick={() => onChange(stepQty(value, sku.qtyStep, 1))}
      >
        +
      </button>
    </div>
  );
}
